import { Type } from 'class-transformer';
import { format } from 'date-fns';
import { Nullable } from '@cast/leadcast-types';
import { SampleOrderStatus } from './SampleOrderStatus';

export interface CurrentSampleOrderStatus {
  id: string;
  orderStatus: SampleOrderStatus;
  orderStatusId: string;
  sampleOrderId: string;
  timestamp: Date;
  comment: Nullable<string>;
}

export class CurrentSampleOrderStatus {
  @Type(() => Date)
  timestamp: Date;

  get timestampDisplay() {
    return format(this.timestamp, 'MM/dd/yyyy');
  }
}
